module.exports = __webpack_public_path__ + "static/media/woman.ad9bfa25.jpg";